import React from 'react'
import { InputTextarea } from 'primereact/inputtextarea'
import _ from 'lodash'

export default function LtsTextArea(props) {
  const onChange = (event) => {
    const target = event.target
    props.onChange(target.value)
  }

  const resolveLabel = () => {
    if (props.label && !props.hidden) {
      return <label>{props.label}</label>
    }
    return null
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <InputTextarea
          {...props}
          value={props.value}
          onChange={onChange}
          name={props.name}
          cols={_.get(props, 'cols', 30)}
          autoResize={true}
          disabled={props.disabled}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
